const getMultipleObjects = (start, end, title, type, key, edit) => {
  return Array(end - start + 1)
    .fill({ expand: true, edit: edit })
    .map((d, i) => ({ ...d, title: title + (i + start), keyValue: key.replace('##', i + start), type: type + (i + start) }))
}
export const CONST_QUESTION_MANAGEMENT_DETAILS = [
  ...getMultipleObjects(1, 4, 'Item Question ', 'itemQuestion', 'question##Value', true),
  ...getMultipleObjects(5, 7, 'Item Question ', 'itemQuestion', 'question##Value', false),
  ...getMultipleObjects(11, 15, 'Item Question ', 'itemQuestion', 'question##Value', false),
  ...getMultipleObjects(1, 2, 'Multiple-choice Item Question ', 'questionMulti', 'questionMulti##Value', false),
  { expand: true, title: 'User Global Question 1', type: 'globalQuestion1', keyValue: 'question1Value', edit: false },
  ...getMultipleObjects(1, 5, 'User Local Question ', 'localQuestion', 'question##Value', true),
  ...getMultipleObjects(7, 12, 'User Local Question ', 'localQuestion', 'question##Value', true),
  { expand: true, title: 'Copy Question', type: 'copyQuestion', keyValue: 'copyQuestion', edit: false }
]

export const CONST_SUB_QUESTION_MANAGEMENT_DETAILS = [
  { expand: true, title: 'Item Sub Question 1A', type: 'itemSubQuestion1A', keyValue: 'question1AValue', edit: false },
  { expand: true, title: 'Item Sub Question 1B', type: 'itemSubQuestion1B', keyValue: 'question1BValue', edit: false },
  { expand: true, title: 'Item Sub Question 3A', type: 'itemSubQuestion3A', keyValue: 'question3AValue', edit: false },
  { expand: true, title: 'Item Sub Question 3B', type: 'itemSubQuestion3B', keyValue: 'question3BValue', edit: false },
  { expand: true, title: 'User Local Sub Question 1A', type: 'userLocalSubQuestion1A', keyValue: 'question1AValue', edit: false },
  { expand: true, title: 'User Local Sub Question 1B', type: 'userLocalSubQuestion1B', keyValue: 'question1BValue', edit: false },
  { expand: true, title: 'User Local Sub Question 3A', type: 'userLocalSubQuestion3A', keyValue: 'question3AValue', edit: false },
  { expand: true, title: 'User Local Sub Question 3B', type: 'userLocalSubQuestion3B', keyValue: 'question3BValue', edit: false },
  { expand: true, title: 'Copy Question', type: 'copyQuestion', keyValue: 'copyQuestion', edit: false }
]

export const CONST_QUESTION_MANAGEMENT_DETAILS__ = [
  {
    expand: true,
    title: 'Item Question 1',
    type: 'question1'
  },
  {
    expand: true,
    title: 'Item Question 2',
    type: 'question2'
  },
  {
    expand: true,
    title: 'Item Question 3',
    type: 'question3'
  },
  {
    expand: true,
    title: 'Item Question 4',
    type: 'question4'
  },
  {
    expand: true,
    title: 'Item Question 5',
    type: 'question5'
  },
  {
    expand: true,
    title: 'Item Question 6',
    type: 'question6'
  },
  {
    expand: true,
    title: 'Item Question 7',
    type: 'question7'
  },
  {
    expand: true,
    title: 'Item Question 11',
    type: 'question11'
  },
  {
    expand: true,
    title: 'Item Question 12',
    type: 'question12'
  },
  {
    expand: true,
    title: 'Item Question 13',
    type: 'question13'
  },
  {
    expand: true,
    title: 'Item Question 14',
    type: 'question14'
  },
  {
    expand: true,
    title: 'Item Question 15',
    type: 'question15'
  },
  {
    expand: true,
    title: 'Multiple-choice Item Question 1',
    type: 'questionMulti1'
  },
  {
    expand: true,
    title: 'Multiple-choice Item Question 2',
    type: 'questionMulti2'
  },
  {
    expand: true,
    title: 'User Global Question 1',
    type: 'globalQuestion1'
  },
  {
    expand: true,
    title: 'User Local Question 1',
    type: 'localQuestion1'
  },
  {
    expand: true,
    title: 'User Local Question 2',
    type: 'localQuestion2'
  },
  {
    expand: true,
    title: 'User Local Question 3',
    type: 'localQuestion3'
  },
  {
    expand: true,
    title: 'User Local Question 4',
    type: 'localQuestion4'
  },
  {
    expand: true,
    title: 'User Local Question 5',
    type: 'localQuestion5'
  }
]
